export enum ElementId {
  partecipazioniInAziendeAppartenentiASettoriNonEtici = 'partecipazioniInAziendeAppartenentiASettoriNonEtici',
  datiEBilanciAggiornati = 'datiEBilanciAggiornati',
  assenzaDiCriticitaNegativitaDellImpresaTarget = 'assenzaDiCriticitaNegativitaDellImpresaTarget',
  analisiDiAltreAnomalieECentraleRischiNegliUltimi12Mesi = 'analisiDiAltreAnomalieECentraleRischiNegliUltimi12Mesi',
  accessoStoricoAProcedureRistrNeDebitiEStatusCorrenteInProceduraOAltraFormaDiRistrNeDebiti = 'accessoStoricoAProcedureRistrNeDebitiEStatusCorrenteInProceduraOAltraFormaDiRistrNeDebiti',
  ricezioneAutorizzazioneAllOpenBankingDelBorrower = 'ricezioneAutorizzazioneAllOpenBankingDelBorrower',
  verificaAnomalieSuOpenBankingNegliUltimi3Mesi = 'verificaAnomalieSuOpenBankingNegliUltimi3Mesi',
  esistenzaFunzioneDiControlloBudgetingAggiornatiInAzienda = 'esistenzaFunzioneDiControlloBudgetingAggiornatiInAzienda',
  ipotecariaPegnoPrivilegioSpeciale = 'ipotecariaPegnoPrivilegioSpeciale',
  garanziePersonali = 'garanziePersonali',
  garanzieDiAntergazioneContrattualeOGiudiziale = 'garanzieDiAntergazioneContrattualeOGiudiziale',
  garanzieAtipiche = 'garanzieAtipiche',
  ddImmobiliareAspettiTecnici = 'ddImmobiliareAspettiTecnici',
  aspettiDiRegolaritaConformitaAmministrativaUrbanistica = 'aspettiDiRegolaritaConformitaAmministrativaUrbanistica',
  ddLegaleSuGaranziePersonaliOReali = 'ddLegaleSuGaranziePersonaliOReali',
  coerenzaFlussiDiErogazioneConStatiAvanzamentoLavori = 'coerenzaFlussiDiErogazioneConStatiAvanzamentoLavori',
  esistenzaDiContrattiDiPrelettingPresale = 'esistenzaDiContrattiDiPrelettingPresale',
}
